import { useState, useEffect } from "react";
import axios from "axios";
import ProgressBar from "./ProgressBar";

const baseUrl = process.env.REACT_APP_PUBLIC_API_URL

const ValueChainCard = () => {
  const [valueChainStats, setValueChainStats] = useState({
    yesDefinitely: null,
    maybe: null,
    no: null,
  });
  const [top6ValueChains, setTop6ValueChains] = useState([]);

  useEffect(() => {
    axios
      .get(`${baseUrl}/value-chain`)
      .then((response) => {
        const resData = response.data;
        if (resData.success) {
          setValueChainStats({
            yesDefinitely: resData.yesDefinitely || 0,
            maybe: resData.maybe || 0,
            no: resData.no || 0,
          });
          setTop6ValueChains(resData.top6ValueChains || []);
        }
      })
      .catch((error) => console.error("Error fetching value chain stats:", error));
  }, []);

  const total = (valueChainStats.yesDefinitely || 0) + (valueChainStats.maybe || 0) + (valueChainStats.no || 0);
  let interestPercentage = null;
  if (total > 0 && valueChainStats.yesDefinitely) {
    interestPercentage = Math.round(((valueChainStats.yesDefinitely + (valueChainStats.maybe || 0)) / total) * 1000) / 10;
  }

  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm">
      <h2 className="text-lg font-semibold mb-1">Value Chain Interest</h2>

      <div className="flex justify-between text-sm mb-4">
        <span className="text-gray-500">Interest in Agriculture</span>
        <span className="text-green-700 font-semibold">
          {interestPercentage ? `${interestPercentage}%` : "—"}
        </span>
      </div>

      <div className="text-sm space-y-1 mb-6">
        <div className="flex justify-between">
          <span>Yes, definitely</span>
          <span className="text-green-700 font-semibold">
            {valueChainStats.yesDefinitely ? valueChainStats.yesDefinitely.toLocaleString() : "—"}
          </span>
        </div>
        <div className="flex justify-between">
          <span>Maybe</span>
          <span className="text-green-700 font-semibold">
            {valueChainStats.maybe ? valueChainStats.maybe.toLocaleString() : "—"}
          </span>
        </div>
        <div className="flex justify-between">
          <span>No</span>
          <span className="text-red-500 font-semibold">
            {valueChainStats.no ? valueChainStats.no.toLocaleString() : "—"}
          </span>
        </div>
      </div>

      <hr className="my-6" />

      <h3 className="font-medium mb-4">Top 6 Selected Value Chain</h3>

      <div className="space-y-4">
        {top6ValueChains.length > 0 ? (
          top6ValueChains.map((item) => (
            <div key={item.name}>
              <div className="flex justify-between text-sm mb-1">
                <span className="text-green-900">{item.name}</span>
                <span className="text-red-700 font-semibold">
                  {item.count.toLocaleString()} ({item.percent}%)
                </span>
              </div>
              <ProgressBar value={item.percent} />
            </div>
          ))
        ) : (
          <p className="text-sm text-gray-500">No value chain data yet.</p>
        )}
      </div>
    </div>
  );
};

export default ValueChainCard;